import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  IOdbCoverDetailDivisionSummaryCategories,
  OdbCoverDetailDivisionType,
} from '@dch/billing-business-logic';
import { odbCategoryDetailsFeatureKey } from '../reducers';
import { IOdbBillCategoryDetailsState } from '../reducers/odb-category-details.reducer';

export const selectOdbCategoryDetails =
  createFeatureSelector<IOdbBillCategoryDetailsState>(
    odbCategoryDetailsFeatureKey
  );

export const selectOdbCategoryDetailsByDocumentReferenceAndCategorySelector = (
  documentReference: string,
  category:
    | keyof IOdbCoverDetailDivisionSummaryCategories
    | OdbCoverDetailDivisionType
) =>
  createSelector(
    selectOdbCategoryDetails,
    (state) =>
      state.odbBillCategoryDetailsByDocumentReference[documentReference]?.[
        category
      ]
  );
